import React from 'react';
import { Wrench, RefreshCw, HardHat, ArrowRight } from 'lucide-react';
export function ProjectTypes() {
  const scrollToTop = () => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  return <section className="py-20 bg-white border-t border-slate-200" data-id="element-247">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248">
        <div className="text-center mb-16" data-id="element-249">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900" data-id="element-250">
            What Kind of Commercial Glass Project Do You Need?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-10" data-id="element-251">
          {/* Card 1 */}
          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200 flex flex-col h-full relative overflow-hidden" data-id="element-252">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary-100 rounded-bl-full -mr-4 -mt-4 opacity-50" data-id="element-253"></div>
            <Wrench className="w-10 h-10 text-primary-600 mb-6 relative z-10" data-id="element-254" />
            <h3 className="kosins-heading text-3xl text-neutral-900 mb-4" data-id="element-255">
              Storefront or Door Repair
            </h3>
            <div className="mb-4 text-sm font-semibold text-slate-500 uppercase tracking-wider" data-id="element-256">
              Best for:
            </div>
            <ul className="space-y-3 mb-8 flex-grow" data-id="element-257">
              {['Broken storefront glass', 'Damaged commercial door glass', 'Cracked business window glass', 'Failed insulated glass units', 'Existing building service or maintenance'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-700" data-id="element-258">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-2 shrink-0" data-id="element-259"></div>
                  <span data-id="element-260">{item}</span>
                </li>)}
            </ul>
            <button onClick={scrollToTop} className="w-full py-3 px-4 bg-white border-2 border-primary-600 text-primary-700 font-semibold rounded-lg hover:bg-primary-50 transition-colors flex items-center justify-center gap-2 group" data-id="element-261">
              Repair My Storefront Glass
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-262" />
            </button>
          </div>

          {/* Card 2 */}
          <div className="bg-navy-900 rounded-2xl p-8 border border-navy-800 flex flex-col h-full relative overflow-hidden shadow-xl transform md:-translate-y-4" data-id="element-263">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary-600 rounded-bl-full -mr-4 -mt-4 opacity-20" data-id="element-264"></div>
            <RefreshCw className="w-10 h-10 text-primary-400 mb-6 relative z-10" data-id="element-265" />
            <h3 className="kosins-heading text-3xl text-white mb-4" data-id="element-266">
              Renovation or Replacement
            </h3>
            <div className="mb-4 text-sm font-semibold text-slate-400 uppercase tracking-wider" data-id="element-267">
              Best for:
            </div>
            <ul className="space-y-3 mb-8 flex-grow" data-id="element-268">
              {['Business window replacement', 'Storefront upgrades', 'Office remodels', 'Glass wall installation', 'Lobby or entryway improvements'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-300" data-id="element-269">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary-400 mt-2 shrink-0" data-id="element-270"></div>
                  <span data-id="element-271">{item}</span>
                </li>)}
            </ul>
            <button onClick={scrollToTop} className="w-full py-3 px-4 bg-primary-600 text-white font-semibold rounded-lg hover:bg-primary-500 transition-colors flex items-center justify-center gap-2 group" data-id="element-272">
              Plan a Commercial Glass Upgrade
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-273" />
            </button>
          </div>

          {/* Card 3 */}
          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200 flex flex-col h-full relative overflow-hidden" data-id="element-274">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary-100 rounded-bl-full -mr-4 -mt-4 opacity-50" data-id="element-275"></div>
            <HardHat className="w-10 h-10 text-primary-600 mb-6 relative z-10" data-id="element-276" />
            <h3 className="kosins-heading text-3xl text-neutral-900 mb-4" data-id="element-277">
              Contract Glazing
            </h3>
            <div className="mb-4 text-sm font-semibold text-slate-500 uppercase tracking-wider" data-id="element-278">
              Best for:
            </div>
            <ul className="space-y-3 mb-8 flex-grow" data-id="element-279">
              {['New construction', 'Tenant build-outs', 'Exterior glazing systems', 'Curtain walls and storefront systems', 'Projects needing bid coordination, fabrication and installation'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-700" data-id="element-280">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-2 shrink-0" data-id="element-281"></div>
                  <span data-id="element-282">{item}</span>
                </li>)}
            </ul>
            <button onClick={scrollToTop} className="w-full py-3 px-4 bg-white border-2 border-primary-600 text-primary-700 font-semibold rounded-lg hover:bg-primary-50 transition-colors flex items-center justify-center gap-2 group" data-id="element-283">
              Request a Contract Glazing Bid
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-284" />
            </button>
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-285">
          <p className="text-sm text-slate-500 bg-slate-100 py-3 px-6 rounded-full inline-block" data-id="element-286">
            Kosin’s Glass can review your scope, photos, measurements, drawings,
            timeline and location to recommend the right next step.
          </p>
        </div>
      </div>
    </section>;
}